import { Injectable } from '@angular/core';
import { TableData } from '../../../shared/types/api-response.types';
import { DcuToMtuCommunication } from './dcu-to-mtu-communication.types';
import { ExportCsvConfig } from 'src/app/services/file/export-data.service';

@Injectable({ providedIn: 'root' })
export class DcuToMtuCommunicationModelService {
  readonly exportCsv = {
    fileName: 'Export-MTUToDCUCommunication',
    mapData: (data: TableData<DcuToMtuCommunication>): ExportCsvConfig[] => {
      return data.data.flatMap(row => {
        const {
          coverage,
          mtuId,
          serviceLocationIdRows,
          serviceLocationAddressRows,
          dcu,
          transmissionCount,
          averageRSSI,
          reliability,
          dcuReceptionAnalyticsItems
        } = row;

        if (dcuReceptionAnalyticsItems.length >= 1) {
          return dcuReceptionAnalyticsItems.map((_, index) => ({
            mtuId: { title: 'MTUID', value: mtuId },
            serviceLocationIdRows: { title: 'ServiceLocationNumber', value: serviceLocationIdRows.join('; ') },
            serviceLocationAddressRows: {
              title: 'ServiceLocationAddress',
              value: serviceLocationAddressRows.join('; ')
            },
            coverage: { title: 'Coverage', value: coverage },
            dcuId: { title: 'DCUID', value: dcu[index].dcuId },
            transmissionCount: { title: 'TransmissionCount', value: transmissionCount[index] },
            averageRSSI: { title: 'AverageRSSI', value: averageRSSI[index] },
            reliability: { title: 'Reliability', value: reliability[index] }
          }));
        } else {
          return [
            {
              mtuId: { title: 'MTUID', value: mtuId },
              serviceLocationIdRows: {
                title: 'ServiceLocationNumber',
                value: serviceLocationIdRows.join('; ')
              },
              serviceLocationAddressRows: {
                title: 'ServiceLocationAddress',
                value: serviceLocationAddressRows.join('; ')
              },
              coverage: { title: 'Coverage', value: coverage },
              dcuId: { title: 'DCUID', value: '' },
              transmissionCount: { title: 'TransmissionCount', value: '' },
              averageRSSI: { title: 'AverageRSSI', value: '' },
              reliability: { title: 'Reliability', value: '' }
            }
          ];
        }
      });
    }
  };
}
